import { FunctionalityService } from "../../api/functionality-service";
import { EOSService } from "../../api/eos-service";
import Result from "../../model/result";

const state = {
    //permissionList: [],
};

const getters = {};

const actions = {
    async getPersonDayWorksTotal(state, { params }) {
        return await FunctionalityService.getPersonDayWorksTotal(params).then((response) => {
            ////console.log(response);
            var data = response.data
            if (data.ResponseResultType === 1) {
                //commit('setPermissionList', data.Values);
                ////console.log(data.Values);
                return Result.success(data.Values)
            } else {
                return Result.error(data.Message)
            }
        })
    },
    async GetPersonDayWorks(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        if (!params.get('perno')) {
            params.append('perno', perno);
        }

        return await FunctionalityService.GetPersonDayWorks(params).then((response) => {
            ////console.log(response);
            var data = response.data
            if (data.ResponseResultType === 1) {
                return Result.success(data.Values)
            } else {
                return Result.error(data.Message)
            }
        })
    },
    async GetPersonDayWorksDetail(state, { params }) {
        var _params = new URLSearchParams()
        var perno = state.rootState.auth.auth.username;
        if (params.perno) {
            _params.append('perno', params.perno);
        } else {
            _params.append('perno', perno);
        }

        _params.append('date', params.date);

        return await EOSService.makeRequest(FunctionalityService.GetPersonDayWorksDetail(_params))
    }
};

const mutations = {
    //setPermissionList: (state, permissionList) => (state.permissionList = permissionList)
};

export default {
    state,
    getters,
    actions,
    mutations
}